export * from './animal-base';
export * from './trait';
